export default __webpack_public_path__ + "static/media/gel-top.fe1315c5.svg";